/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { injectIntl, intlShape } from 'react-intl';
import { createUseStyles } from 'react-jss';

import styles from './LoginLinkSuccess.style';
import messages from 'src/shared/app/authentication/l10n/loginLinkL10n';
import SuccessBanner from 'src/shared/app/base/component/notification/SuccessBanner';
import SecondaryTopBar from 'src/shared/app/base/component/template/component/SecondaryTopBar';
import SecondaryButton from 'src/shared/ui/component/button/SecondaryButton';
import InstructionText from 'src/shared/ui/component/text/InstructionText';

type Props = {
  username: string,
  handleResendLink: (username: string) => void,
  // Self passed
  // $FlowIssue
  intl: intlShape,
};

const useStyles = createUseStyles(styles);

const LoginLinkSectionDumb = ({
  username,
  handleResendLink,
  intl,
}: Props): React.Node => {
  const classes: Object = useStyles();

  return (
    <div className={classes.root}>
      <SecondaryTopBar>
        <SuccessBanner
          text={intl.formatMessage(messages.success, { email: username })}
        />
      </SecondaryTopBar>
      <div className={classes.action}>
        <SecondaryButton handleClick={handleResendLink}>
          {intl.formatMessage(messages.resend)}
        </SecondaryButton>
      </div>
      <InstructionText>
        {intl.formatMessage(messages.resendInfo)}
      </InstructionText>
    </div>
  );
};

export default compose(injectIntl)(LoginLinkSectionDumb);
